import { Location } from "history";
import { matchPath } from "react-router-dom";

import { MODAL_ROUTES } from "routing/routes";

import {
  linkToAssignmentSummaryRoute,
  linkToParentWhatIsPremium,
  linkToSettings
} from "features/parents/links";
import { linkToChildAssignmentsPage } from "features/parents/routes/parent/routes/child/routes/assignments/links";
import { FeedbackParamKey } from "features/parents/routes/parent/routes/feedback/consts";
import { linkToMorePage } from "features/parents/routes/parent/routes/mobile/more/links";

export function locationIncludesMoreRoute(location: Location) {
  return (
    location.pathname.includes(linkToMorePage()) ||
    location.pathname.includes(linkToSettings()) ||
    location.pathname.includes(FeedbackParamKey) ||
    location.pathname.includes(MODAL_ROUTES.CHOOSE_REGION.path) ||
    location.pathname.includes(linkToParentWhatIsPremium())
  );
}

export function locationIncludesAssignmentsRoute({
  location,
  selectedChildId
}: {
  location: Location;
  selectedChildId: string | undefined;
}) {
  return (
    location.pathname.includes(linkToChildAssignmentsPage(selectedChildId)) ||
    !!matchPath(location.pathname, { path: linkToAssignmentSummaryRoute() })
  );
}
